import matchers from "../../validate-props/matchers";

export const actionTypes = {
    next: "next",
    prev: "prev",
    set: "set",
};

/**
 * The Iterator reducer is designed allow navigating through a list using actions like next and prev.
 * It depends on a initial data set and will always start in the first position
 * @param {Set} collection
 * @return {Function} reducer function that will process old state + action
 */
const Iterator = (collection) => {
    if (!matchers.instanceof(Set)(collection)) {
        return;
    }
    const arrayList = Array.from(collection);
    const total = arrayList.length - 1;
    /**
     * @param {String} state one of the actions inside the initial map
     * @param {{
     * type:String,
     * value?:String
     * }} state one of the actions inside the initial map
     */
    return (state, action) => {
        if (!matchers.object(action) || !(action.type in actionTypes)) {
            return state;
        }

        const { type, value } = action;

        // Values that are not on set
        if (!collection.has(state)) {
            return state;
        }

        const currentIndex = arrayList.reduce((acc, val, index) => {
            if (val === state) acc = index;
            return acc;
        }, 0);

        switch (type) {
            case actionTypes.next:
                if (currentIndex < total) {
                    return arrayList[currentIndex + 1];
                }
                return arrayList[0];

            case actionTypes.prev:
                if (currentIndex > 0) {
                    return arrayList[currentIndex - 1];
                }
                return arrayList[total];
            case actionTypes.set:
                if (collection.has(value)) return value;
                return state;
            default:
                return state;
        }
    };
};

export default Iterator;
